import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalsService } from '../../shared/services/globals.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { DQOIReferenceData } from '../../shared/models/DQOIReferenceData';
import { GItem } from '@app/cp/shared/models/GItem';
import { DispatchBoardService } from '../../shared/services/dispatch-board.service';
import { WindowContents } from '../../shared/enums/windowContents';
import { DispatchBoardSearch } from '@app/cp/shared/models/DispatchBoardSearch';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';

import { CommonFunctions } from '../../shared/static/common-functions';
import { CDocument } from '../../shared/models/CDocument';
import { CommonValues } from '../../shared/static/CommonValues';
import { PrintService } from '@app/cp/shared/services/print.service';
import { UseCPLoader, ICPLoader } from '@app/cp/shared/decorators/cploader/cploader-decorator';
import { UsersBus } from '@app/cp/shared/models/UsersBus.model';
import { CmProAuthService } from '@app/core/services';

@UseCPLoader()
@Component({
    selector: 'cp-dispatch-board-ribbon',
    templateUrl: './dispatch-board-ribbon.component.html',
    styleUrls: ['./dispatch-board-ribbon.component.scss']
})
export class DispatchBoardRibbonComponent  implements OnInit, OnDestroy {
    compLoader: ICPLoader = this as any;
    sch: DispatchBoardSearch = new DispatchBoardSearch(null);
    sort: string;
    qry_rd: DQOIReferenceDataQuery;
    referenceData: DQOIReferenceData;
    subs_dataRef: Subscription;
    selectedStates: any;
    refreshTimer: number;
    lastRefreshTime: Date = new Date();
    public filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains'
    };
    //edit views
    //boardViews: any;
    boardViewStatuses: any;
    boardViewTechs: any;
    public static virtualizationSettings = { itemHeight: 30, pageSize: 100 };
    filterSummary: any = {
        divisions: [],
        srvConst: [],
        acctClasses: [],
        states: [],
        acctMgrs: [],
        onCallRegions: [],
        customers: [],
        filterSummary:[]
    };

    @Input() boardViews: any;
    @Output() selectedBoardView = new EventEmitter<string>();
    @Input() selectedView: any;
    chkOTOntop: Boolean = true;
    @Output() toggleColor = new EventEmitter<boolean>()
    toggleColorIcon: boolean = true;

    subscriptions: Subscription[] = [];
    subs_dataRefUpdated: Subscription;
    constructor(private globals: GlobalsService, qry_rd: DQOIReferenceDataQuery, private svc_data: DispatchBoardService, private printService: PrintService, private authService: CmProAuthService) {
        this.qry_rd = qry_rd;
    }

    ngOnInit() {
        this.subs_dataRef = this.qry_rd.ensureRefDataIsLoaded(this.globals.companyId).subscribe();
        this.subs_dataRefUpdated = this.qry_rd.referenceDataUpdated.subscribe((data: DQOIReferenceData) => {
            if (!data) {
                return;
            }
            this.referenceData = data;
            this.referenceData.srvConst = this.srvConst;
        });

        this.subscriptions.push(this.svc_data.refreshTrigger$.subscribe(
            refresh => {
                this.lastRefreshTime = new Date(Date.now());
            }));

        this.authService.subscribeToLoginEvents((user: UsersBus) => {
            if (user) {
                this.sch.userId = user.userid;
                this.svc_data.searchParams = this.sch;
                this.getDefaultFilter();
                this.checkForColor();
            }
        });


    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
        CommonFunctions.unsubscribe(this.subs_dataRef);
        CommonFunctions.unsubscribe(this.subs_dataRefUpdated);
        this.authService.unsubscribeToLoginEvents();
    }

    public viewBuilder: boolean = false;
    public showFilter: boolean = false;

    manRefresh() {
        this.svc_data.manRefresh();
    }
    public filter() {
        this.showFilter = true;
    }

    applyFilters() {
        this.closeFilter();
        this.svc_data.searchParams = this.sch;
        this.svc_data.dispatchSort = this.sort;
        this.svc_data.manRefresh();
        this.setFilterSummary();
    }
    defaultFilters() {
        this.sch.dispatchViewId = CommonValues.Guid_Empty;
        this.sch.sort = this.sort;
        this.svc_data.updateDispatchFilter(this.sch).subscribe(data => {
            if (data.error) {
                this.globals.notifyError("Error Saving Default Filters.");
            }
            else {

                this.globals.notifySuccess("Default Filters saved .");
            }
        });
    }
    getDefaultFilter() {

        this.svc_data.getDispatchFilter().subscribe(data => {
            if (data.saveError) {

            }
            else {
                var tempsch = new DispatchBoardSearch(data.primaryReturn);
                this.sch.acctClasses = tempsch.acctClasses;
                this.sch.acctMgrs = tempsch.acctMgrs;
                this.sch.active = tempsch.active;
                this.sch.customers = tempsch.customers;
                this.sch.onCallRegions = tempsch.onCallRegions;
                this.sch.divisions = tempsch.divisions;
                this.sch.states = tempsch.states;
                this.sort = tempsch.sort;
                this.sch.srvConst = tempsch.srvConst;
                if (this.hasSearchParams()) {
                    this.applyFilters();
                }
            }
        });
    }
    closeFilter() {
        this.showFilter = false;
        this.viewBuilder = false;
    }

    public printOptions: Array<any> = [
        {text: 'Print a schedule'},
        {text: 'Print a schedule for this view'}
    ];
    public iconClass = 'fas fa-print';

    onPrintClick(e){
        let index = this.printOptions.indexOf(e);
        switch (index) {
            case 0:
                this.print();
                break;
            case 1:
                this.printView();
                break;
        }
    }

    print() {
        this.compLoader.cpLoader = true;
        this.svc_data.print('all').subscribe((data: CDocument) => {
            if (CommonFunctions.hasValue(data)) {
                if (CommonFunctions.hasValue(data.document)) {
                    this.printService.printPdf(data);
                }
                else if(data.fileName === "NR") {
                    this.globals.notifyWarning("There were no records to print.");
                }
                else  {
                    this.globals.notifyWarning("No data found.");
                }
            }
            else {
                this.globals.notifyError("There was an error printing the schedule: ");
            }
            this.compLoader.cpLoader = false;
        });
    }
    printView() {
        this.compLoader.cpLoader = true;
        this.svc_data.print(this.selectedView).subscribe((data: CDocument) => {
            if (CommonFunctions.hasValue(data)) {
                if (CommonFunctions.hasValue(data.document)) {
                    this.printService.printPdf(data);
                }
                else if (data.fileName === "NR") {
                    this.globals.notifyWarning("There were no records to print.");
                }
                else {
                    this.globals.notifyWarning("No data found.");
                }
            }
            else {
                this.globals.notifyError("There was an error printing the schedule: ");
                //this.notify("There was and error printing the schedule: " + info.message, "E");
                //this.mainLoadingOff(true);
            }
            this.compLoader.cpLoader = false;
        });
    }
	//Viewbuilder
	@Output() openRequest = new EventEmitter<object>();
	public contentTypes = WindowContents;
    hasSearchParams() {
        if (this.sch.divisions && this.sch.divisions.length > 0) return true;
        if (this.sch.states && this.sch.states.length > 0) return true;
        if (this.sch.acctMgrs && this.sch.acctMgrs.length > 0) return true;
        if (this.sch.acctClasses && this.sch.acctClasses.length > 0) return true;
        if (this.sch.onCallRegions && this.sch.onCallRegions.length > 0) return true;
        if (this.sch.customers && this.sch.customers.length > 0) return true;
        if (this.sch.srvConst) return true;

        return false;
    }
    showBuilder() {
		let windowData;
        windowData = { contentType: this.contentTypes.dbViewBuilder };
		this.openRequest.emit(windowData);
    }

    boardSelected(e) {
        this.sch.boardViewId = e ? e.dispatchViewId : null;
        this.svc_data.searchParams = this.sch;
        this.selectedBoardView.emit(e);
    }

    //edit views
    selectBoardView(view: any) {
        this.svc_data.GetDispatchBoardViewStatuses(view.dispatchViewId).subscribe(data => {
            this.boardViewStatuses = data;
        });
        this.svc_data.GetDispatchBoardViewPersons(view.dispatchViewId).subscribe(data => {
            this.boardViewTechs = data;
        });
    }

    setFilterSummary() {
        this.filterSummary.divisions = [];
        if (this.sch.divisions) {
            this.sch.divisions.forEach(item => {
                this.filterSummary.divisions.push(this.referenceData.divisions[this.findNameByGuid(this.referenceData.divisions, item)].description);
            });
        }
        this.filterSummary.srvConst = this.sch.srvConst;
        this.filterSummary.acctClasses = [];
        if (this.sch.acctClasses) {
            this.sch.acctClasses.forEach(item => {
                this.filterSummary.acctClasses.push(this.referenceData.accountClasses[this.findNameByGuid(this.referenceData.accountClasses, item)].description);
            });
        }
        this.filterSummary.states = [];
        if (this.sch.states && this.referenceData && this.referenceData.states) {
            this.sch.states.forEach(item => {
                this.filterSummary.states.push(this.referenceData.states[this.findNameByGuid(this.referenceData.states, item)].description);
            });
        }
        this.filterSummary.acctMgrs = [];
        if (this.sch.acctMgrs) {
            this.sch.acctMgrs.forEach(item => {
                this.filterSummary.acctMgrs.push(this.referenceData.acctMgrs[this.findNameByGuid(this.referenceData.acctMgrs, item)].description);
            });
        }
        this.filterSummary.onCallRegions = [];
        if (this.sch.onCallRegions) {
            this.sch.onCallRegions.forEach(item => {
                this.filterSummary.onCallRegions.push(this.referenceData.onCallRegions[this.findNameByGuid(this.referenceData.onCallRegions, item)].description);
            });
        }
        this.filterSummary.customers = [];
        if (this.sch.customers) {
            this.sch.customers.forEach(item => {
                this.filterSummary.customers.push(this.referenceData.customers[this.findNameByGuid(this.referenceData.customers, item)].description);
            });
        }
    }

    findNameByGuid(array, guid) {
        if (!array) {
            return new GItem();
        }
        let test = array.findIndex(function (element) {
            return element.value == guid;
        });
        return test;
    }

    public srvConst: GItem[] = [
        {
            description: "All",
            value: "All",
            category: "type", "reference": null
        },
        {
            description: "Service",
            value: "Service",
            category: "type", "reference": null
        },
        {
            description: "Construction",
            value: "Construction",
            category: "type", "reference": null
        }
    ];

    public statusSort: GItem[] = [
        {
            description: "Created, Priority, Location",
            value: "CreatedPriorityLocation",
            category: "status", "reference": null
        }, {
            description: "Customer, Location",
            value: "CustomerLocation",
            category: "status", "reference": null
        }, {
            description: "Rank",
            value: "Rank",
            category: "status", "reference": null
        }, {
            description: "Time in Status",
            value: "TimeInStatus",
            category: "status", "reference": null
        }
    ];

    public gropupBy: Array<string> = [
        "Date",
        "Resource"
    ];

    toggleDispatchColor(){
        this.toggleColorIcon = !this.toggleColorIcon;
        this.toggleColor.emit();
        if (this.toggleColorIcon) {
            localStorage.setItem("DispatchColor", 'true');
        } else {
            localStorage.setItem("DispatchColor", 'false');
        }
    }

    checkForColor(){

        this.toggleColorIcon = localStorage.getItem( "DispatchColor" ) == 'true';
    }
}
